import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@ncoder/ui';
import { PerformanceItem } from '../../atoms/training/PerformanceItem';

interface PerformanceMetricsProps {
  responseQuality: string;
  contextUnderstanding: string;
  taskCompletion: string;
}

export const PerformanceMetrics: React.FC<PerformanceMetricsProps> = ({
  responseQuality,
  contextUnderstanding,
  taskCompletion,
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Performance Metrics</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-3">
          <PerformanceItem label="Response Quality" value={responseQuality} />
          <PerformanceItem label="Context Understanding" value={contextUnderstanding} />
          <PerformanceItem label="Task Completion" value={taskCompletion} />
        </div>
      </CardContent>
    </Card>
  );
};
